<app-versatile-list>
    <app-versatile-list-header [isLoading]="isLoading">
        <ng-container *ngIf="!isLoading && (headerTitle || headerSubtitle) && internalItems?.length > 0; else headerPlaceholder">
            <app-scroll-list-item
                [title]="headerTitle"
                [subtitle]="headerSubtitle"
                [description]="headerDescription"
                [leftIcon]="headerLeftIcon"
                [rightIcon]="headerRightIcon"
                [selected]="false"
                [highlighted]="false"
                (rightIconClick)="toggleEditable()">
            </app-scroll-list-item>
        </ng-container>
        <ng-template #headerPlaceholder>
            <div class="header-placeholder" *ngIf="!isLoading">
                <div class="title">{{ resolvedPlaceholderTitle }}</div>
                <div class="subtitle">{{ resolvedPlaceholderSubtitle }}</div>
            </div>
        </ng-template>
    </app-versatile-list-header>

    <app-versatile-list-body
        [items]="internalItems"
        [total]="internalItems?.length || 0"
        [isLoading]="isLoading"
        [useVirtualScroll]="false">
        <ng-template versatileListItem let-item let-index="index">
            <app-sample-board-material-scan-item
                class="list__item"
                [item]="item"
                [index]="index"
                [parentForm]="getOrCreateGroup(item)"
                [canEdit]="editable"
                [canEditCode]="editable">
            </app-sample-board-material-scan-item>
        </ng-template>

        <ng-container versatileListEmpty>
            <app-empty-state
                icon="fa-square-o"
                [text]="(i18nKey + '.empty') | translate">
            </app-empty-state>
        </ng-container>
    </app-versatile-list-body>

    <app-versatile-list-footer [isLoading]="isLoading">
        <ng-container *ngIf="!isLoading">
            <div class="footer-info">
                <div class="footer-title">{{ footerTitle }}</div>
                <div class="footer-meta">{{ footerSubtitle }}</div>
            </div>
            <div class="footer-actions" *ngIf="editable">
                <app-button type="simple" (clicked)="onCancel()">
                    {{ 'generic.buttons.cancel' | translate }}
                </app-button>
                <app-button type="primary" (clicked)="onSave()">
                    {{ 'generic.buttons.save' | translate }}
                </app-button>
            </div>
        </ng-container>
    </app-versatile-list-footer>
</app-versatile-list>
